import React, { useState } from "react";
import OurExpertService from "../components/landingpage/OurExpertService";
import { useParams } from "react-router-dom";

const HeaderLinkPage = () => {
  return (
    <div className="w-full flex flex-col items-center gap-5 lg:gap-[72px] ruler">
      <OurExpertService />
    </div>
  );
};

export default HeaderLinkPage;
